import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {ApiService} from "../../../services/api.service";
import { NoFrameComponent } from '../../../frames/no-frame/no-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { KazInputComponent } from '../../../components/kaz-input/kaz-input.component';
import { KazButtonComponent } from '../../../components/kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoFrameComponent, FaIconComponent, KazInputComponent, KazButtonComponent]
})
export class ResetComponent implements OnInit, OnDestroy {
  private _Router = inject(ActivatedRoute);
  private _api = inject(ApiService);

  mail: string = '';
  subscription: Subscription | null = null;
  wasSend: boolean = false;

  ngOnInit() {
    this.subscription = this._Router.queryParams.subscribe(params => {
      this.mail = params['mail'] ?? '';
    })
  }

  ngOnDestroy(){
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  isDisabled() {
    return !/[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}/.test(this.mail);
  }

  async sendResetMail() {
    try {
      const data = await this._api.setResetPasswordToken(this.mail);
      this.wasSend = true;
    } catch (err) {
      console.log(err);
    }
  }
}
